import { noop } from 'lodash'
import { Map } from 'ol'
import { createContext } from 'react'

import { TMapContextValue } from './types'

export const MapContext = createContext<TMapContextValue>({
  map: new Map(),
  refMap: null,
  jumpTo: noop,
  zoom: noop,
  centerAllElements: noop,
  fitExtent: noop,
})
